import { RectangleMarkerController } from '../rectangle/rectangleMarkerController'
import { MarkerModes } from '../../types'

class SelectionMarkerController extends RectangleMarkerController {
  constructor(marker) {
    super(marker)
  }

  mouseClickedEvent(): void {
    return
  }

  mousePressedEvent(): void {
    const position = this.marker.state.position
    const dimensions = this.marker.state.dimensions
    const isCreating = this.marker.state.mode === MarkerModes.Create

    this.marker.state.isPressed = true
    this.updateMousePosition()
    this.updateMouseDelta()

    //Instantiate dimensions and position
    if (isCreating) {
      position.x = this.mouseCoordinateX
      position.y = this.mouseCoordinateY
      dimensions.height = 0
      dimensions.width = 0
    }
  }

  mouseDraggedEvent(): void {
    super.mouseDraggedEvent()
    if (typeof this.marker.markerEditCallback === 'function') this.marker.markerEditCallback(this.marker)
  }
}

export { SelectionMarkerController }
